import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { OpenIdConnectAction, OpenIdConnectSelector } from "@obg/common.verification";
import { CoreState, SESSION_ACTION_TYPE } from "@obg/ngx.core";
import { filter, map, withLatestFrom } from "rxjs/operators";

@Injectable()
export class OpenIdConnectEffect {
	openIdConnectLogout$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(SESSION_ACTION_TYPE.logout),
				withLatestFrom(this.store.select(this.oidcSelector.getToken())),
				filter((token) => !!token),
				map(() => this.store.dispatch(this.openIdConnectAction.clearOpenIdConnectToken()))
			),
		{ dispatch: false }
	);

	constructor(
		private actions$: Actions,
		private store: Store<CoreState>,
		private oidcSelector: OpenIdConnectSelector,
		private openIdConnectAction: OpenIdConnectAction
	) {}
}
